export { VehicleSummary } from './VehicleSummary';
